import React from 'react'
import {Switch} from 'react-router-dom'
import Login from '../pages/Login'
import Home from '../pages/Home'
import AuthenticatedRoute from './AuthenticatedRoute'
import UnauthenticatedRoute from './UnauthenticatedRoute'

const Routes = props => {
    return (
        <Switch>
            <UnauthenticatedRoute
                path="/login"
                exact
                component={Login}
                {...props}
            />
            <AuthenticatedRoute path="/" component={Home} {...props} />
        </Switch>
    )
}
export default Routes
